import PropTypes from 'prop-types'

import theme from 'theme'
import Password from 'components/authentication/form-fields/Password'

export default function SAMLRequired({ message, samlUrl }) {
  return (
    <div data-test-saml-required data-test-saml-url={samlUrl}>
      <small css={{ marginBottom: theme.space[4], display: 'block' }}>
        {message}
      </small>
      <Password
        handleSaml={() => (window.location.href = samlUrl)}
        signInMethods={['saml']}
      />
    </div>
  )
}

SAMLRequired.propTypes = {
  message: PropTypes.string.isRequired,
  samlUrl: PropTypes.string.isRequired
}
